'use client';
import ProjectsLayout from '@/layout/ProjectsLayout';

export default function Layout({ children }) {
  return <ProjectsLayout>{children}</ProjectsLayout>;
}
